// Constants
module.exports = {
  //Boleto premio ogx 
  // IMAGE_CP:'https://s3.amazonaws.com/clubpremierstyleguide/cpstyleguidestaging/images/bg-login-white.png',
  // SENDOTP: 'https://ogxzztwku8.execute-api.us-east-2.amazonaws.com/dev/franchises/sendOtp',
  // VALIDATEOTP: 'https://ogxzztwku8.execute-api.us-east-2.amazonaws.com/dev/franchises/validateOtp',
  // AGENTOOL:'http://agenttool.s3-website-us-west-1.amazonaws.com/?token=',/* DEV_IDS */
  // // AGENTOOL:'http://agenttoolqa.s3-website.us-east-2.amazonaws.com/?token=',/* QA_IDS */
  // // AGENTOOL: 'http://localhost:3001/?token=',
  // GETPROFILECORP: 'https://ogxzztwku8.execute-api.us-east-2.amazonaws.com/dev/cp/getcorporateprofile',
  // LOGGIN: 'https://ogxzztwku8.execute-api.us-east-2.amazonaws.com/dev/franchises/login',
  // VERIFY: 'https://ogxzztwku8.execute-api.us-east-2.amazonaws.com/dev/franchises/verify',
  // CHANGE: 'https://ogxzztwku8.execute-api.us-east-2.amazonaws.com/dev/franchises/change',
  // RETRIVE: 'https://ogxzztwku8.execute-api.us-east-2.amazonaws.com/dev/franchises/retrive',
  // GENERATETOKEN: 'https://ogxzztwku8.execute-api.us-east-2.amazonaws.com/dev/franchises/security',
  // MODULE_SKIP: 'Boleto',
  
  // DEV
  // IMAGE_CP: "https://s3.amazonaws.com/clubpremierstyleguide/cpstyleguidestaging/images/bg-login-white.png",
  // SENDOTP: "https://revenueapi.clubpremier.info/dev/franchises/sendOtp",
  // VALIDATEOTP: "https://revenueapi.clubpremier.info/dev/franchises/validateOtp",
  // AGENTOOL:"http://agenttoolqa.s3-website-us-west-1.amazonaws.com/?token=" /* DEV_IDS */,
  // // AGENTOOL:'http://agenttoolqa.s3-website.us-east-2.amazonaws.com/?token=',/* QA_IDS */
  // // AGENTOOL: 'http://localhost:3001/?token=',
  // GETPROFILECORP: "https://revenueapi.clubpremier.info/dev/cp/getcorporateprofile",
  // LOGGIN: "https://revenueapi.clubpremier.info/dev/franchises/login",
  // VERIFY: "https://revenueapi.clubpremier.info/dev/franchises/verify",
  // CHANGE: "https://revenueapi.clubpremier.info/dev/franchises/change",
  // RETRIVE: "https://revenueapi.clubpremier.info/dev/franchises/retrive",
  // GENERATETOKEN: "https://revenueapi.clubpremier.info/dev/franchises/security",
  // AMV_GENERATE_AGENT_TOKEN: "https://revenueapi.clubpremier.info/dev/amVacations/createAgentToken",
  // AMV_GET_CRIS_PROFILE: "https://revenueapi.clubpremier.info/dev/amVacations/getCrisToken",
  // MODULE_SKIP: "Boleto",

  //UAT
// IMAGE_CP:'https://s3.amazonaws.com/clubpremierstyleguide/cpstyleguidestaging/images/bg-login-white.png',
// SENDOTP: 'https://apibpamruat.clubpremier.info/franchises/sendOtp',
// VALIDATEOTP: 'https://apibpamruat.clubpremier.info/franchises/validateOtp',
// AGENTOOL:'https://atoolmauat.clubpremier.info/?token=',
// GETPROFILECORP:"https://apibpamruat.clubpremier.info/cp/getcorporateprofile",
// LOGGIN: 'https://apibpamruat.clubpremier.info/franchises/login',
// VERIFY: 'https://apibpamruat.clubpremier.info/franchises/verify',
// CHANGE: 'https://apibpamruat.clubpremier.info/franchises/change',
// RETRIVE: 'https://apibpamruat.clubpremier.info/franchises/retrive',
// GENERATETOKEN: 'https://apibpamruat.clubpremier.info/franchises/security',
// AMV_GENERATE_AGENT_TOKEN: 'https://apibpamruat.clubpremier.info/amVacations/createAgentToken',
// AMV_GET_CRIS_PROFILE: 'https://apibpamruat.clubpremier.info/amVacations/getCrisToken',
// MODULE_SKIP: 'Boleto',


  //UAT API DIRECTA
  // IMAGE_CP:'https://s3.amazonaws.com/clubpremierstyleguide/cpstyleguidestaging/images/bg-login-white.png',
  // VALIDATEOTP: 'https://4hyb4anplj.execute-api.us-east-1.amazonaws.com/pro/franchises/validateOtp',
  // AGENTOOL:'https://atoolmauat.clubpremier.info/?token=',
  // GETPROFILECORP:"https://4hyb4anplj.execute-api.us-east-1.amazonaws.com/pro/cp/getcorporateprofile",
  // LOGGIN: 'https://4hyb4anplj.execute-api.us-east-1.amazonaws.com/pro/franchises/login',
  // VERIFY: 'https://4hyb4anplj.execute-api.us-east-1.amazonaws.com/pro/franchises/verify',
  // CHANGE: 'https://4hyb4anplj.execute-api.us-east-1.amazonaws.com/pro/franchises/change',
  // RETRIVE: 'https://4hyb4anplj.execute-api.us-east-1.amazonaws.com/pro/franchises/retrive',
  // GENERATETOKEN: 'https://4hyb4anplj.execute-api.us-east-1.amazonaws.com/pro/franchises/security',
  // MODULE_SKIP: 'Boleto',
  // SENDOTP: 'https://4hyb4anplj.execute-api.us-east-1.amazonaws.com/pro/franchises/sendOtp',




  //QA
  // IMAGE_CP:'https://s3.amazonaws.com/clubpremierstyleguide/cpstyleguidestaging/images/bg-login-white.png',
  // SENDOTP: 'https://apibpamrqa.clubpremier.info/franchises/sendOtp',
  // VALIDATEOTP: 'https://apibpamrqa.clubpremier.info/franchises/validateOtp',
  // AGENTOOL:'https://atoolmaqa.clubpremier.info/?token=',
  // GETPROFILECORP:"https://apibpamrqa.clubpremier.info/cp/getcorporateprofile",
  // LOGGIN: 'https://apibpamrqa.clubpremier.info/franchises/login',
  // VERIFY: 'https://apibpamrqa.clubpremier.info/franchises/verify',
  // CHANGE: 'https://apibpamrqa.clubpremier.info/franchises/change',
  // RETRIVE: 'https://apibpamrqa.clubpremier.info/franchises/retrive',
  // GENERATETOKEN: 'https://apibpamrqa.clubpremier.info/franchises/security',
  // AMV_GENERATE_AGENT_TOKEN: 'https://apibpamrqa.clubpremier.info/amVacations/createAgentToken',
  // AMV_GET_CRIS_PROFILE: 'https://apibpamrqa.clubpremier.info/amVacations/getCrisToken',
  // MODULE_SKIP: 'Boleto',

  // LIVE
 IMAGE_CP:'https://s3.amazonaws.com/clubpremierstyleguide/cpstyleguidestaging/images/bg-login-white.png',
 SENDOTP: 'https://apibpamr.aeromexicorewards.com/franchises/sendOtp',
 VALIDATEOTP: 'https://apibpamr.aeromexicorewards.com/franchises/validateOtp',
 AGENTOOL:'https://atoolma.clubpremier.com/?token=',
 LOGGIN: 'https://apibpamr.aeromexicorewards.com/franchises/login',
 GETPROFILECORP:"https://apibpamr.aeromexicorewards.com/cp/getcorporateprofile",
 VERIFY: 'https://apibpamr.aeromexicorewards.com/franchises/verify',
 CHANGE: 'https://apibpamr.aeromexicorewards.com/franchises/change',
 RETRIVE: 'https://apibpamr.aeromexicorewards.com/franchises/retrive',
 GENERATETOKEN: 'https://apibpamr.aeromexicorewards.com/franchises/security',
 AMV_GENERATE_AGENT_TOKEN: 'https://apibpamr.aeromexicorewards.com/amVacations/createAgentToken',
 AMV_GET_CRIS_PROFILE: 'https://apibpamr.aeromexicorewards.com/amVacations/getCrisToken',
 MODULE_SKIP: 'Boleto',

  ACTIVE_CORPORATE_FR: 1, // 1 Activa venta corporativo FR 0 desactiva
};



// WEBPACK FOOTER //
// ./src/constants/constants.js